// src/utils/uuid.js

/**
 * 生成一个符合 RFC4122 v4 版本的 UUID
 * @returns {string} UUID
 */
export function generateUUID() {
  // crypto.randomUUID() 是现代浏览器内置的、性能最好的标准方法
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // 兼容旧版浏览器或非安全上下文环境
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
